module.exports = __webpack_public_path__ + "img/story018.5efd1aa5.webp";